import "./Home.module.css";
import GlobalNavigation from "@/reusable_sections/Header";
import HersBinsServices from "./sections/HersBinsServices";
import TrustedByTheSecure from "./sections/TrustedByTheSecure";
import SpecializedExpertise from "./sections/SpecializedExpertise";
import TheFynnPhilosophy from "./sections/TheFynnPhilosophy";
import TheAiMagicBehindTheLens from "./sections/TheAiMagicBehindTheLens";
import GrowthJourney from "./sections/GrowthJourney";
import PassengerSuccessStories from "./sections/PassengerSuccessStories";
import LatestLegalInsights from "./sections/LatestLegalInsights";
import ScaleYourRetailEmpire from "./sections/ScaleYourRetailEmpire";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <GlobalNavigation />
      <HersBinsServices />
      <TrustedByTheSecure />
      <SpecializedExpertise />
      <TheFynnPhilosophy />
      <TheAiMagicBehindTheLens />
      <GrowthJourney />
      <PassengerSuccessStories />
      <LatestLegalInsights />
      <ScaleYourRetailEmpire />
      <Footer />
    </div>;
}